<template>
    <v-container grid-list-md fluid>
        <v-row class="d-flex justify-space-between mb-1">
            <v-col cols="6" class="d-flex flex-column">
                <v-row no-gutters>
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11">
                        <h2>{{ $t("audit." + key + ".corporateTaxCalculation") }}</h2>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <!-- ** upload -->
                    <v-tooltip location="bottom" text="Lier un document">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-upload"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>
                    <!-- ** chat -->
                    <v-tooltip location="bottom" text="Message">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-chat"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod ||
                            auditItems.validated ||
                            loading ||
                            dataLoading ||
                            !accountingPeriod
                        "
                        @click.stop="storeReinstatementsAndDeductions()"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <v-btn
                        rounded
                        :disabled="
                            disabledBtnGlobalValidation ||
                            loading ||
                            dataLoading ||
                            !accountingPeriod
                        "
                        @click="validateFunction()"
                        size="small"
                    >
                        {{ auditItems.validated ? "Invalider" : "Valider" }}
                    </v-btn>
                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !auditItems.validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                storeReinstatementsAndDeductions('REVIEW');
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !auditItems.validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                storeReinstatementsAndDeductions('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>
                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                        "
                    />
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>
                        <v-list nav>
                            <v-list-item @click="displayActivityDialog = true">
                                <v-list-item-title>Afficher l'activité</v-list-item-title>
                                <template v-slot:append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>

                            <template v-if="!showDeleteAcrBtnIfRecovery">
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <div no-gutters v-bind="props">
                                            <v-list-item no-gutters disabled>
                                                <v-list-item-title>
                                                    Supprimer le contrôle
                                                </v-list-item-title>

                                                <template v-slot:append>
                                                    <v-icon size="small"> $oss-trash </v-icon>
                                                </template>
                                            </v-list-item>
                                        </div>
                                    </template>
                                    <span>{{ showDeleteAcrBtnTooltipMessage }}</span>
                                </v-tooltip>
                            </template>

                            <template v-else>
                                <v-list-item
                                    no-gutters
                                    @click="deleteAuditCheckResultDialog = true"
                                >
                                    <v-list-item-title> Supprimer le contrôle </v-list-item-title>

                                    <template v-slot:append>
                                        <v-icon>$oss-trash</v-icon>
                                    </template>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>

        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >
            <!-- ** loading -->
            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <!-- ** no accountinPeriod -->
            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" color="red" size="large"> $oss-warning </v-icon>
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <!-- ** finished loading and accountingPeriod -->
            <template v-else>
                <!-- ** closed accountingPeriod -->
                <v-row
                    no-gutters
                    v-if="closedPeriod"
                    class="d-flex flex-column justify-center align-center mb-3"
                >
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Période clôturée</h3>
                </v-row>

                <!-- ** bundleSheet - feuillet de la liasse -->
                <v-row v-if="bundleSheetId">
                    <template
                        v-if="
                            auditItems &&
                            auditItems.bundleSheetToRegenerate &&
                            auditItems.bundleErrorMessage &&
                            auditItems.bundleErrorMessage.message
                        "
                    >
                        <v-spacer />
                        <v-col>
                            <v-btn-warning
                                size="x-small"
                                color="red"
                                @click="regenerateBundleDialog = true"
                            >
                            </v-btn-warning>
                        </v-col>
                    </template>

                    <v-col v-else>
                        <div class="pa-3">
                            <v-row no-gutters>
                                <v-col cols="12" class="d-flex align-center">
                                    <p class="px-4 py-0 ma-0">
                                        La liasse est ici affichée en lecture seule.
                                    </p>
                                    <v-btn
                                        class="px-4"
                                        rounded
                                        color="primary"
                                        @click="
                                            $router.push({
                                                name: 'taxForm2',
                                                params: { id: auditItems.bundle.id },
                                            })
                                        "
                                        size="small"
                                    >
                                        Liasse
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>

                        <TaxFormReadOnly :id="bundleSheetId"> </TaxFormReadOnly>
                    </v-col>
                </v-row>

                <!-- ** no bundleSheetId -->
                <template v-else>
                    <!-- ** accountingPeriod is open -->
                    <v-icon
                        v-if="auditItems && accountingPeriod && !accountingPeriod.closed"
                        size="x-small"
                        color="red"
                        @click="generateNewBundleDialog = true"
                        icon="$oss-warning"
                    />

                    <!-- // no existing bundleSheetId and accounting period is closed -->
                    <!-- // AccountingTable - Compte de résultat -->
                    <!-- ** accountingPeriod.closed -->
                    <template v-else-if="accountingPeriod.closed">
                        <v-card
                            elevation="0"
                            style="background-color: white; border-radius: 25px"
                            class="pa-6 mt-4"
                        >
                            <v-row>
                                <!-- // ** title ************** -->
                                <v-col cols="auto" class="ma-auto">
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-card-title class="ma-0 pa-0">
                                                <h5 class="pl-4">
                                                    {{ $t("audit." + key + ".incomeStatement") }} -
                                                    <template
                                                        v-if="
                                                            auditItems.resultBeforeReintegrationsDeductionsAnd695 &&
                                                            auditItems.resultBeforeReintegrationsDeductionsAnd695 <
                                                                0
                                                        "
                                                    >
                                                        Bénéfice comptable avant réintégrations,
                                                        déductions et impôts :
                                                    </template>

                                                    <template v-else>
                                                        Perte comptable avant réintégrations,
                                                        déductions et impôts :
                                                    </template>

                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(
                                                                auditItems.resultBeforeReintegrationsDeductionsAnd695,
                                                            ),
                                                            undefined,
                                                        )
                                                    }}
                                                </h5>
                                            </v-card-title>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-card-subtitle>
                                                dont Résultat comptable :
                                                {{ newCommonFormatCurrency(-netResultAmount) }} + IS
                                                déjà comptabilisé en c/695 :
                                                {{ newCommonFormatCurrency(booked695Amount) }}
                                            </v-card-subtitle>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <v-spacer />

                                <v-col cols="1" class="d-flex align-center px-0 justify-center">
                                    <v-row>
                                        <v-col cols="6" class="align-center">
                                            <!-- <v-icon
                                                v-if="auditItems.validatedTable"
                                                color="primary"
                                                class="px-2" icon="$check_circle" /> -->
                                        </v-col>

                                        <!-- // ** expand icon -->
                                        <v-col cols="6" class="align-center">
                                            <v-btn-icon
                                                :icon="
                                                    showIncomeStatement
                                                        ? '$fa-chevron-up'
                                                        : '$fa-chevron-down'
                                                "
                                                @click="showIncomeStatement = !showIncomeStatement"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <v-expand-transition>
                                <div v-show="showIncomeStatement">
                                    <v-card-text class="pt-2 pb-0">
                                        <AccountingTable
                                            v-if="periodsAccountingTable"
                                            :options="{
                                                title: 'Compte de résultat',
                                                className: 'INCOME_STATEMENT',
                                            }"
                                            :periods="periodsAccountingTable"
                                            :tags="[]"
                                            @table="fetchResult($event)"
                                            :key="refreshAccountingTable"
                                        >
                                        </AccountingTable>

                                        <!-- // ** btns -->
                                        <!-- <v-row no-gutters class="text-right pt-4">
                                            <v-spacer></v-spacer> -->
                                        <!-- // ** enregistrer -->
                                        <!-- <v-col cols="auto" class="text-right pr-4">
                                                <v-btn v-if="closedPeriod || auditItems.validatedTable"
                                                     size="small"
                                                    dense
                                                    rounded
                                                    color="primary"

                                                    elevation="0"
                                                    disabled
                                                >
                                                    Enregistrer
                                                </v-btn>

                                                <v-btn
                                                    v-else
                                                     size="small"
                                                    dense
                                                    rounded
                                                    color="primary"

                                                    elevation="0"
                                                    @click="storeReinstatementsAndDeductions()"
                                                >
                                                    Enregistrer
                                                </v-btn>
                                            </v-col> -->

                                        <!-- // ** si false > valider -->
                                        <!-- <v-col cols="auto" class="text-right">
                                                <v-btn
                                                    v-if="closedPeriod"
                                                     size="small"
                                                    dense
                                                    rounded
                                                    color="primary"

                                                    elevation="0"
                                                    disabled
                                                >
                                                    {{$t('audit.validate')}}
                                                </v-btn>

                                                <v-btn
                                                    v-else-if="!auditItems.validatedTable"
                                                     size="small"
                                                    dense
                                                    rounded
                                                    color="primary"

                                                    elevation="0"
                                                    @click="auditItems.validatedTable = !auditItems.validatedTable; storeReinstatementsAndDeductions();"
                                                    >
                                                    {{$t('audit.validate')}}
                                                </v-btn> -->

                                        <!-- // ** si true > invalider -->
                                        <!-- <v-btn
                                                    v-else
                                                     size="small"
                                                    dense
                                                    rounded
                                                    color="primary"

                                                    elevation="0"
                                                    @click="auditItems.validatedTable = !auditItems.validatedTable; storeReinstatementsAndDeductions();"
                                                    >
                                                    Invalider
                                                </v-btn>
                                            </v-col>
                                        </v-row> -->
                                    </v-card-text>
                                </div>
                            </v-expand-transition>
                        </v-card>

                        <!-- // ************************************************************************* -->
                        <!-- // ********* expand : table - Éléments d'analyse - adjustmentTable ********* -->
                        <v-card
                            elevation="0"
                            style="background-color: white; border-radius: 25px"
                            class="pa-6 mt-4"
                        >
                            <v-row>
                                <!-- // ** title ************** -->
                                <v-col cols="auto" class="ma-auto">
                                    <v-card-title class="ma-0 pa-0">
                                        <h5 class="pl-4">
                                            {{ $t("audit." + key + ".analysisElements") }}
                                        </h5>
                                    </v-card-title>
                                </v-col>

                                <v-spacer />

                                <v-col cols="1" class="d-flex align-center px-0 justify-center">
                                    <v-row>
                                        <v-col cols="6" class="d-flex align-center">
                                            <v-icon
                                                v-if="auditItems.validatedTable"
                                                color="primary"
                                                icon="$check_circle"
                                                size="large"
                                            />
                                        </v-col>

                                        <!-- // ** expand icon -->
                                        <v-col cols="6" data-cy="CheckCorporateTax-checkCircle">
                                            <v-btn-icon
                                                :icon="
                                                    showTable
                                                        ? '$fa-chevron-up'
                                                        : '$fa-chevron-down'
                                                "
                                                @click="showTable = !showTable"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <v-expand-transition>
                                <div v-show="showTable">
                                    <v-card-text class="pt-2 pb-0" v-if="adjustmentTable">
                                        <v-data-table
                                            :headers="auditItems.adjustmentTableHeaders"
                                            :items="adjustmentTable"
                                            :expanded="expanded"
                                            item-key="tableBlock"
                                            show-expand
                                            :loading="loading"
                                            class="table"
                                            style="border: 1px #ededed solid"
                                            fixed-header
                                            hide-default-footer
                                            :items-per-page="-1"
                                        >
                                            <template #no-data>Aucune charge à réintégrer</template>

                                            <template v-slot:item="props">
                                                <tr :style="props.item.style">
                                                    <!-- // ** accountableAccounts -->
                                                    <td
                                                        cols="auto"
                                                        v-if="
                                                            props.item.accountableAccounts
                                                                .length === 1
                                                        "
                                                        class="text-end"
                                                    >
                                                        {{ props.item.accountableAccounts[0] }}
                                                    </td>

                                                    <td
                                                        cols="auto"
                                                        v-else-if="
                                                            props.item.accountableAccounts.length >=
                                                            1
                                                        "
                                                        class="text-end"
                                                    >
                                                        {{
                                                            accountableAccountNames(
                                                                props.item.accountableAccounts,
                                                            )
                                                        }}
                                                    </td>

                                                    <td cols="auto" v-else />

                                                    <!-- // ** description -->
                                                    <td
                                                        v-if="props.item.tableBlock"
                                                        style="border-left: 1px solid #dddddd"
                                                        class="text-left"
                                                    >
                                                        <!-- ** preTaxProfitOrLoss and taxableTaxResult have condition wording 'Bénéfice || Déficit' -->
                                                        <template
                                                            v-if="
                                                                [
                                                                    'preTaxProfitOrLoss',
                                                                    'taxableTaxResult',
                                                                ].includes(props.item.tableBlock)
                                                            "
                                                        >
                                                            {{ props.item.wording }}
                                                        </template>

                                                        <template v-else>
                                                            {{
                                                                $t(
                                                                    "audit." +
                                                                        key +
                                                                        "." +
                                                                        props.item.tableBlock,
                                                                )
                                                            }}
                                                        </template>
                                                    </td>

                                                    <td
                                                        v-else-if="props.item.wording"
                                                        style="border-left: 1px solid #dddddd"
                                                        class="text-left"
                                                    >
                                                        {{ props.item.wording }}
                                                    </td>

                                                    <td
                                                        v-else
                                                        style="border-left: 1px solid #dddddd"
                                                        class="text-left"
                                                    />

                                                    <!-- // ** normaTaxSystem -->
                                                    <td
                                                        v-if="props.item.normalTaxSystem"
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 100px;
                                                        "
                                                        class="text-center"
                                                    >
                                                        {{ props.item.normalTaxSystem }}
                                                    </td>

                                                    <td
                                                        v-else
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 100px;
                                                        "
                                                        class="text-center"
                                                    />

                                                    <!-- // ** bncTaxSystem -->
                                                    <td
                                                        v-if="props.item.bncTaxSystem"
                                                        class="text-center"
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 100px;
                                                        "
                                                    >
                                                        {{ props.item.bncTaxSystem }}
                                                    </td>

                                                    <td
                                                        v-else
                                                        class="text-center"
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 100px;
                                                        "
                                                    />

                                                    <!-- // ** computedAmountSigned -->
                                                    <td
                                                        v-if="props.item.computedAmountSigned"
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 170px;
                                                        "
                                                        class="text-right"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                Math.abs(
                                                                    props.item.computedAmountSigned,
                                                                ),
                                                                { currency: "", DC: true },
                                                            )
                                                        }}
                                                        <v-btn-icon
                                                            icon="$remove_red_eye"
                                                            v-if="props.item.normalTaxSystem"
                                                            @click.stop="setDetailsList(props.item)"
                                                        />
                                                    </td>

                                                    <td
                                                        v-else-if="
                                                            props.item.style ===
                                                            'background-color: #78c5c2; font-weight: bold;'
                                                        "
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 170px;
                                                        "
                                                        class="text-right"
                                                    >
                                                        -
                                                    </td>

                                                    <td
                                                        v-else-if="
                                                            props.item.accountableAccounts
                                                                .length === 1
                                                        "
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 170px;
                                                        "
                                                        class="text-right"
                                                    >
                                                        0
                                                    </td>

                                                    <td
                                                        v-else
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 170px;
                                                        "
                                                        class="text-right"
                                                    />

                                                    <!-- // ** manualAmountSigned -->
                                                    <!-- // ** white input lines -->
                                                    <td
                                                        v-if="
                                                            props.item.normalTaxSystem &&
                                                            auditItems.validatedTable
                                                        "
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 170px;
                                                        "
                                                        class="text-right py-2;"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                Math.abs(
                                                                    props.item.manualAmountSigned,
                                                                ),
                                                                { currency: "", DC: true },
                                                            )
                                                        }}
                                                    </td>
                                                    <td
                                                        v-else-if="props.item.normalTaxSystem"
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 170px;
                                                        "
                                                        class="text-right py-2;"
                                                    >
                                                        <oss-text-field
                                                            outlined
                                                            dense
                                                            hide-details
                                                            v-model="props.item.manualAmountSigned"
                                                            style="width: 170px"
                                                            @update:model-value="changeAmounts()"
                                                            @click.stop
                                                        >
                                                        </oss-text-field>
                                                    </td>

                                                    <!-- // ** green total lines  -->
                                                    <td
                                                        v-else-if="props.item.manualAmountSigned"
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 170px;
                                                        "
                                                        class="text-right"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                Math.abs(
                                                                    props.item.manualAmountSigned,
                                                                ),
                                                                { currency: "", DC: true },
                                                            )
                                                        }}
                                                    </td>

                                                    <!-- // ** green empty lines -->
                                                    <td
                                                        v-else-if="
                                                            props.item.style ===
                                                            'background-color: #f8f8f8'
                                                        "
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 170px;
                                                        "
                                                        class="text-right"
                                                    >
                                                        0,00 &#x20ac;
                                                    </td>

                                                    <!-- // ** title lines -->
                                                    <td
                                                        v-else
                                                        style="
                                                            border-left: 1px solid #dddddd;
                                                            width: 170px;
                                                        "
                                                        class="text-center"
                                                    />

                                                    <!-- // ** props.item.comment -->
                                                    <td
                                                        v-if="props.item.normalTaxSystem"
                                                        class="text-center"
                                                    >
                                                        <v-btn-icon
                                                            icon="$comment "
                                                            v-if="closedPeriod"
                                                            dense
                                                            color="primary"
                                                            elevation="0"
                                                            disabled
                                                            size="small"
                                                        />

                                                        <v-btn-icon
                                                            icon="
                                                                $comment

                                                                $comment
                                                            "
                                                            v-else
                                                            dense
                                                            color="primary"
                                                            elevation="0"
                                                            @click="
                                                                addAdjustmentTableExpand(props.item)
                                                            "
                                                            size="small"
                                                        />
                                                    </td>

                                                    <td v-else style="width: 68.75px" />
                                                </tr>
                                            </template>

                                            <template v-slot:expanded-row="{ columns, item }">
                                                <td
                                                    v-if="
                                                        !!item.comment &&
                                                        (closedPeriod || auditItems.validated)
                                                    "
                                                    :colspan="columns.length"
                                                    style="
                                                        height: 120px;
                                                        padding-top: 0;
                                                        margin-top: 0;
                                                    "
                                                >
                                                    <v-textarea-filled
                                                        outlined
                                                        hide-details
                                                        dense
                                                        v-model="item.comment"
                                                        style="
                                                            margin-right: auto;
                                                            margin-left: auto;
                                                            padding: 10px;
                                                            border: 1px #ededed solid;
                                                        "
                                                        disabled
                                                    />
                                                </td>

                                                <td
                                                    v-else-if="!!item.displayComment"
                                                    :colspan="columns.length"
                                                    style="
                                                        height: 120px;
                                                        padding-top: 0;
                                                        margin-top: 0;
                                                    "
                                                >
                                                    <v-textarea-filled
                                                        outlined
                                                        hide-details
                                                        dense
                                                        v-model="item.comment"
                                                        style="
                                                            margin-right: auto;
                                                            margin-left: auto;
                                                            padding: 10px;
                                                            border: 1px #ededed solid;
                                                        "
                                                        @update:model-value="addComment(item)"
                                                    />
                                                </td>
                                            </template>
                                        </v-data-table>

                                        <!-- // ** btns -->
                                        <v-row no-gutters class="text-right pt-4">
                                            <v-spacer />
                                            <!-- // ** enregistrer -->
                                            <v-col cols="auto" class="text-right pr-4">
                                                <v-btn
                                                    :disabled="closedPeriod || auditItems.validated"
                                                    dense
                                                    rounded
                                                    elevation="0"
                                                    @click="storeReinstatementsAndDeductions()"
                                                    size="small"
                                                >
                                                    Enregistrer
                                                </v-btn>
                                            </v-col>

                                            <!-- // ** si false > valider -->
                                            <v-col cols="auto" class="text-right">
                                                <v-btn
                                                    v-if="!auditItems.validatedTable"
                                                    :disabled="closedPeriod || auditItems.validated"
                                                    dense
                                                    rounded
                                                    elevation="0"
                                                    @click="
                                                        auditItems.validatedTable = true;
                                                        showTable = false;
                                                        storeReinstatementsAndDeductions(
                                                            'VALIDATE',
                                                        );
                                                    "
                                                    data-cy="CheckCorporateTax-valid"
                                                    size="small"
                                                >
                                                    Valider le résultat fiscal imposable
                                                </v-btn>

                                                <!-- // ** si true > invalider -->
                                                <v-btn
                                                    v-else
                                                    :disabled="closedPeriod || auditItems.validated"
                                                    dense
                                                    rounded
                                                    elevation="0"
                                                    @click="
                                                        auditItems.validatedTable = false;
                                                        storeReinstatementsAndDeductions('UPDATE');
                                                    "
                                                    data-cy="CheckCorporateTax-unValid"
                                                    size="small"
                                                >
                                                    Invalider le résultat fiscal imposable
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </div>
                            </v-expand-transition>
                        </v-card>
                    </template>
                </template>

                <!-- // ************************************************************** -->
                <!-- // ** expand : calculation - Calcul et comptabilisation de l'Impôt sur les Sociétés *** -->
                <v-card class="audit-card">
                    <v-row>
                        <!-- // ** title ************** -->
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">
                                    {{ $t("audit." + key + ".corporateTaxCalculation") }}
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        icon="$check_circle"
                                        v-if="auditItems.validatedTax"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                        color="primary"
                                        size="large"
                                        data-cy="CheckCorporateTax-checkCircle"
                                    />
                                </v-col>

                                <!-- // ** expand icon -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="!openTax ? '$fa-chevron-up' : '$fa-chevron-down'"
                                        @click="openTax()"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-expand-transition>
                        <div v-show="showTax">
                            <v-card-text class="pt-2 pb-0">
                                <v-table :class="table" style="border: 1px #ededed solid">
                                    <tbody style="border: 1px solid #c4c4c4">
                                        <!-- // ** taxableTaxResult ** -->
                                        <tr style="background-color: #f8f8f8">
                                            <!-- ** 1 -->
                                            <td width="30%" class="pl-4">
                                                <template
                                                    v-if="bundleSheetId && bundleSheetId.length"
                                                >
                                                    <template v-if="preTaxIncome < 0">
                                                        BENEFICE FISCAL IMPOSABLE
                                                    </template>
                                                    <template v-else-if="preTaxIncome > 0">
                                                        DEFICIT FISCAL
                                                    </template>
                                                    <template v-else>
                                                        RESULTAT FISCAL IMPOSABLE
                                                    </template>
                                                </template>

                                                <template
                                                    v-else-if="
                                                        adjustmentTable &&
                                                        adjustmentTable[31] &&
                                                        adjustmentTable[31].manualAmountSigned
                                                    "
                                                >
                                                    <template
                                                        v-if="
                                                            adjustmentTable[31].manualAmountSigned <
                                                            0
                                                        "
                                                    >
                                                        BENEFICE FISCAL IMPOSABLE
                                                    </template>
                                                    <template
                                                        v-else-if="
                                                            adjustmentTable[31].manualAmountSigned >
                                                            0
                                                        "
                                                    >
                                                        DEFICIT FISCAL
                                                    </template>
                                                    <template v-else>
                                                        RESULTAT FISCAL IMPOSABLE
                                                    </template>
                                                </template>
                                            </td>

                                            <!-- ** 2 -->
                                            <!-- // ** résultat fiscal -->
                                            <template v-if="bundleSheetId && bundleSheetId.length">
                                                <td width="20%" class="text-right">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(preTaxIncome),
                                                        )
                                                    }}
                                                </td>
                                            </template>
                                            <template
                                                v-else-if="adjustmentTable && adjustmentTable[31]"
                                            >
                                                <td width="20%" class="text-right">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(
                                                                adjustmentTable[31]
                                                                    .manualAmountSigned,
                                                            ),
                                                        )
                                                    }}
                                                </td>
                                            </template>

                                            <!-- ** v-else NAN to be alerted of third possibility -->
                                            <td width="20%" class="text-right" v-else>NAN</td>

                                            <!-- ** 3  -->
                                            <td
                                                width="20%"
                                                v-if="
                                                    adjustmentTable &&
                                                    adjustmentTable[31] &&
                                                    adjustmentTable[31].manualAmountSigned &&
                                                    adjustmentTable[31].manualAmountSigned >= 0
                                                "
                                            >
                                                Pas d'impôt
                                            </td>
                                            <td
                                                width="20%"
                                                v-else-if="
                                                    bundleSheetId &&
                                                    bundleSheetId.length &&
                                                    preTaxIncome >= 0
                                                "
                                            >
                                                Pas d'impôt
                                            </td>
                                            <td width="20%" v-else />

                                            <!-- ** 4 -->
                                            <td width="10%" class="text-right" />

                                            <!-- ** 5 -->
                                            <td width="20%" class="pr-4" />
                                        </tr>

                                        <!-- // ** salesTurnover ** -->

                                        <template
                                            v-if="
                                                (bundleSheetId && preTaxIncome) ||
                                                (adjustmentTable &&
                                                    adjustmentTable[31] &&
                                                    adjustmentTable[31].manualAmountSigned < 0)
                                            "
                                        >
                                            <tr style="background-color: #f8f8f8">
                                                <!-- ** 1 -->
                                                <td width="30%" class="pl-4">
                                                    {{ $t("audit." + key + ".salesTurnover") }}
                                                </td>

                                                <!-- ** 2 -->
                                                <td
                                                    v-if="auditItems.salesTurnover"
                                                    width="20%"
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(auditItems.salesTurnover),
                                                            { currency: "", DC: true },
                                                        )
                                                    }}
                                                </td>
                                                <td v-else width="20%" class="text-right">-</td>

                                                <!-- ** 3 -->
                                                <template
                                                    v-if="
                                                        auditItems.turnoverLessThen &&
                                                        auditItems.year
                                                    "
                                                >
                                                    <td
                                                        width="20%"
                                                        class="text-start"
                                                        v-if="periodTurnoverBracket0"
                                                    >
                                                        {{
                                                            "CA inférieur à " +
                                                            newCommonFormatCurrency(
                                                                Math.abs(periodTurnoverBracket0),
                                                                undefined,
                                                            )
                                                        }}

                                                        <template
                                                            v-if="
                                                                auditItems.periodMonthDuration != 12
                                                            "
                                                        >
                                                            (prorata de
                                                            {{ auditItems.periodMonthDuration }}
                                                            mois de
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    Math.abs(
                                                                        fullPeriodTurnoverBracket0,
                                                                    ),
                                                                    undefined,
                                                                )
                                                            }})
                                                        </template>
                                                    </td>

                                                    <td
                                                        width="20%"
                                                        class="text-start"
                                                        v-else-if="
                                                            auditItems.preTaxIncomeBrackets &&
                                                            auditItems.preTaxIncomeBracket0
                                                        "
                                                    >
                                                        {{
                                                            "CA inférieur à " +
                                                            newCommonFormatCurrency(
                                                                Math.abs(
                                                                    auditItems.preTaxIncomeBracket0,
                                                                ),
                                                                undefined,
                                                            )
                                                        }}

                                                        <template
                                                            v-if="
                                                                auditItems.periodMonthDuration != 12
                                                            "
                                                        >
                                                            (prorata de
                                                            {{ auditItems.periodMonthDuration }}
                                                            mois de
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    fullPeriodTurnoverBracket0,
                                                                    undefined,
                                                                )
                                                            }})
                                                        </template>
                                                    </td>

                                                    <td v-else width="20%" class="text-start">
                                                        CA >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                periodTurnoverBracket0,
                                                                undefined,
                                                            )
                                                        }}
                                                    </td>
                                                </template>
                                                <td v-else width="20%" class="text-center" />

                                                <!-- ** 4 -->
                                                <td width="10%" class="text-right" />

                                                <!-- ** 5 -->
                                                <td width="20%" />
                                            </tr>

                                            <!-- // ** fullyPaidCapital -->
                                            <tr
                                                v-if="
                                                    auditItems &&
                                                    auditItems.turnoverLessThen &&
                                                    auditItems.year &&
                                                    periodTurnoverBracket0
                                                "
                                                style="background-color: #f8f8f8"
                                            >
                                                <!-- ** 1 -->
                                                <td width="30%" class="pl-4">
                                                    Capital social :
                                                    {{
                                                        newCommonFormatCurrency(
                                                            auditItems.shareCapital,
                                                            { currency: "", DC: true },
                                                        )
                                                    }}
                                                    <!-- {{$t('audit.' + key + '.fullyPaidCapital')}} -->
                                                </td>

                                                <!-- ** 2 -->
                                                <td v-if="c101300" width="20%" class="text-right">
                                                    dont versé :
                                                    {{
                                                        newCommonFormatCurrency(c101300, undefined)
                                                    }}
                                                </td>
                                                <td v-else width="20%" class="text-right">
                                                    Pas de capital versé
                                                </td>

                                                <!-- ** 3 + 4 + 5 -->
                                                <td
                                                    v-if="fullyPaidCapital"
                                                    width="50%"
                                                    class="text-start"
                                                    colspan="3"
                                                >
                                                    Entièrement versé
                                                </td>
                                                <td
                                                    v-else
                                                    width="20%"
                                                    class="text-start"
                                                    colspan="3"
                                                >
                                                    Le capital n'a pas été entièrement versé
                                                </td>
                                            </tr>

                                            <!-- // ** naturalPersonsSharesRateOver75 -->
                                            <tr
                                                v-if="
                                                    auditItems &&
                                                    auditItems.turnoverLessThen &&
                                                    auditItems.year &&
                                                    periodTurnoverBracket0
                                                "
                                                style="background-color: #f8f8f8"
                                            >
                                                <!-- ** 1 -->
                                                <td width="30%" class="pl-4">
                                                    {{
                                                        $t(
                                                            "audit." +
                                                                key +
                                                                ".naturalPersonsSharesRateOver75",
                                                        )
                                                    }}
                                                </td>

                                                <!-- ** 2 -->
                                                <td width="20%" class="text-right">
                                                    <v-checkbox
                                                        :disabled="closedPeriod"
                                                        v-model="naturalPersonsSharesRateOver75"
                                                        :ripple="false"
                                                        class="pa-0 d-flex justify-end"
                                                        @update:model-value="changeAmounts()"
                                                    />
                                                    <!-- color="white" -->
                                                </td>

                                                <!-- ** 3 -->
                                                <td width="20%" />

                                                <!-- ** 4 -->
                                                <td width="10%" class="text-right" />

                                                <!-- ** 5 -->
                                                <td width="20%" class="pr-4" />
                                            </tr>
                                        </template>

                                        <!-- // ** reduced corporateTaxRate ** -->
                                        <template v-if="corporateTaxAmount">
                                            <tr
                                                v-if="
                                                    customerCorporateTaxObject &&
                                                    customerCorporateTaxObject.reduced &&
                                                    customerCorporateTaxObject.reduced.taxBase &&
                                                    customerCorporateTaxObject.reduced.taxRate &&
                                                    customerCorporateTaxObject.reduced.taxAmount
                                                "
                                            >
                                                <!-- ** 1 -->
                                                <td width="30%" class="pl-8">
                                                    Taux réduit - bénéfice plafonné à
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(periodPreTaxIncomeBracket0),
                                                            undefined,
                                                        )
                                                    }}
                                                    <template
                                                        v-if="auditItems.periodMonthDuration != 12"
                                                    >
                                                        (prorata de
                                                        {{ auditItems.periodMonthDuration }} mois de
                                                        {{
                                                            newCommonFormatCurrency(
                                                                Math.abs(
                                                                    auditItems.preTaxIncomeBracket0,
                                                                ),
                                                                undefined,
                                                            )
                                                        }})
                                                    </template>
                                                </td>

                                                <!-- ** 2 -->
                                                <td width="20%" class="text-right">
                                                    Base :
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(
                                                                customerCorporateTaxObject.reduced
                                                                    .taxBase,
                                                            ),
                                                            undefined,
                                                        )
                                                    }}
                                                </td>

                                                <!-- ** 3 -->
                                                <td width="20%">
                                                    <!-- <v-select
                                                        :items="corporateTaxRates"
                                                        v-model="corporateTaxRate"
                                                        item-text="text"
                                                        item-value="value"
                                                        style="display: inline-block; width: 250px"
                                                        dense
                                                        @change="calculateTax"
                                                    ></v-select> -->
                                                    {{
                                                        customerCorporateTaxObject.reduced.taxRate
                                                    }}%
                                                </td>

                                                <!-- ** 4 -->
                                                <td width="10%" class="text-right">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(
                                                                customerCorporateTaxObject.reduced
                                                                    .taxAmount,
                                                            ),
                                                            {},
                                                        )
                                                    }}
                                                </td>

                                                <!-- ** 5 -->
                                                <td width="20%" class="pr-4" />
                                            </tr>

                                            <!-- // ** normal corporateTaxRate ** -->
                                            <tr
                                                v-if="
                                                    customerCorporateTaxObject &&
                                                    customerCorporateTaxObject.normal &&
                                                    customerCorporateTaxObject.normal.taxBase &&
                                                    customerCorporateTaxObject.normal.taxRate &&
                                                    customerCorporateTaxObject.normal.taxAmount
                                                "
                                            >
                                                <!-- ** 1 -->
                                                <td
                                                    v-if="periodPreTaxIncomeBracket1"
                                                    width="30%"
                                                    class="pl-8"
                                                >
                                                    Taux normal
                                                    <template
                                                        v-if="periodPreTaxIncomeBracket1 !== 0"
                                                    >
                                                        - plafonné à
                                                        {{
                                                            newCommonFormatCurrency(
                                                                Math.abs(
                                                                    periodPreTaxIncomeBracket1,
                                                                ),
                                                                undefined,
                                                            )
                                                        }}
                                                        <template
                                                            v-if="
                                                                auditItems.periodMonthDuration != 12
                                                            "
                                                        >
                                                            (prorata de
                                                            {{ auditItems.periodMonthDuration }}
                                                            mois de
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    auditItems.preTaxIncomeBracket1,
                                                                    undefined,
                                                                )
                                                            }})
                                                        </template>
                                                    </template>

                                                    <template v-else> (non plafonné) </template>
                                                </td>

                                                <td width="30%" class="pl-8" v-else>Taux normal</td>

                                                <!-- ** 2 -->
                                                <td width="20%" class="text-right">
                                                    Base :
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(
                                                                customerCorporateTaxObject.normal
                                                                    .taxBase,
                                                            ),
                                                            undefined,
                                                        )
                                                    }}
                                                </td>

                                                <!-- ** 3 -->
                                                <td width="20%" class="text-left">
                                                    {{ customerCorporateTaxObject.normal.taxRate }}%
                                                </td>

                                                <!-- ** 4 -->
                                                <td width="10%" class="text-right">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(
                                                                customerCorporateTaxObject.normal
                                                                    .taxAmount,
                                                            ),
                                                            undefined,
                                                        )
                                                    }}
                                                </td>

                                                <!-- ** 5 -->
                                                <td width="20%" class="pr-4" />
                                            </tr>

                                            <!-- // ** overrun corporateTaxRate ** -->
                                            <tr
                                                v-if="
                                                    customerCorporateTaxObject &&
                                                    customerCorporateTaxObject.overrun &&
                                                    customerCorporateTaxObject.overrun.taxBase &&
                                                    customerCorporateTaxObject.overrun.taxRate &&
                                                    customerCorporateTaxObject.overrun.taxAmount
                                                "
                                            >
                                                <!-- ** 1 -->
                                                <td width="30%" class="pl-8">Taux majoré</td>

                                                <!-- ** 2 -->
                                                <td width="20%" class="text-right">
                                                    Base :
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(
                                                                customerCorporateTaxObject.overrun
                                                                    .taxBase,
                                                            ),
                                                            undefined,
                                                        )
                                                    }}
                                                </td>

                                                <!-- ** 3 -->
                                                <td width="20%">
                                                    {{
                                                        customerCorporateTaxObject.overrun.taxRate
                                                    }}%
                                                </td>

                                                <!-- ** 4 -->
                                                <td width="10%" class="text-right">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(
                                                                customerCorporateTaxObject.overrun
                                                                    .taxAmount,
                                                            ),
                                                            undefined,
                                                        )
                                                    }}
                                                </td>

                                                <!-- ** 5 -->
                                                <td width="20%" class="pr-4" />
                                            </tr>
                                        </template>

                                        <!-- // ** corporateTaxAmount ** -->
                                        <tr style="background-color: #f8f8f8">
                                            <!-- ** 1 -->
                                            <td width="30%" class="pl-4">
                                                {{ $t("audit." + key + ".corporateTax") }}
                                            </td>

                                            <!-- ** 2 -->
                                            <td width="20%" />

                                            <!-- ** 3 -->
                                            <td width="20%" />

                                            <!-- ** 4 -->
                                            <td width="10%" class="text-right">
                                                <v-btn-icon
                                                    icon=" $oss-help"
                                                    @click="corporateTaxSnackbar = true"
                                                />

                                                <v-snackbar
                                                    v-model="corporateTaxSnackbar"
                                                    min-width="50vw"
                                                >
                                                    <h2 class="pb-2">
                                                        Total impôt dû : après eventuelle génération
                                                        de l'écriture, doit correspondre aux soldes
                                                        des comptes 695000 et 444000
                                                    </h2>

                                                    <template #actions>
                                                        <v-btn-icon
                                                            icon="$oss-close"
                                                            size="small"
                                                            @click.stop="
                                                                corporateTaxSnackbar = false
                                                            "
                                                            class="white"
                                                        />
                                                    </template>
                                                </v-snackbar>

                                                <div
                                                    v-for="(
                                                        sentence, index
                                                    ) in customerCorporateTaxSentence()"
                                                    :key="index"
                                                >
                                                    <v-row no-gutters v-if="sentence" class="py-0">
                                                        <v-col> </v-col>
                                                    </v-row>
                                                </div>
                                            </td>

                                            <!-- ** 5 -->
                                            <td width="20%" class="pr-4 text-right">
                                                {{
                                                    newCommonFormatCurrency(
                                                        corporateTaxAmount,
                                                        undefined,
                                                    )
                                                }}
                                            </td>
                                        </tr>

                                        <!-- // ** solde balance c/695 ** -->
                                        <tr>
                                            <!-- ** 1 -->
                                            <td width="30%" class="pl-8">
                                                Solde actuel de la balance c/695, dont
                                            </td>

                                            <!-- ** 2 -->
                                            <td width="20%" class="text-right">
                                                OD manuelle :
                                                {{
                                                    newCommonFormatCurrency(
                                                        onlyManualOdsFromBalances695,
                                                    )
                                                }}
                                            </td>

                                            <!-- ** 3 -->
                                            <td width="20%">
                                                OD générée :
                                                {{
                                                    newCommonFormatCurrency(
                                                        onlyAcrResultsFromBalance695,
                                                    )
                                                }}
                                            </td>

                                            <!-- ** 4 -->
                                            <td width="10%" class="text-right" />

                                            <!-- ** 5 -->
                                            <td width="20%" class="text-right pr-4;">
                                                {{
                                                    newCommonFormatCurrency(
                                                        auditItems.corporateTaxFromBalances695,
                                                        undefined,
                                                    )
                                                }}
                                            </td>
                                        </tr>

                                        <!-- // ** gap balance c/695 ** -->
                                        <tr v-if="c695gap" class="font-weight-bold">
                                            <!-- ** 1 + 2 -->
                                            <td width="50%" class="pl-8" colspan="2">
                                                Ecart entre le solde de la balance c/695 et l'impôt
                                                dû
                                            </td>

                                            <!-- ** 3 -->
                                            <td width="20%">
                                                (OD à régénérer :
                                                {{ newCommonFormatCurrency(toBeBooked) }})
                                            </td>

                                            <!-- ** 4 -->
                                            <td width="10%" class="text-right" />

                                            <!-- ** 5 -->
                                            <td width="20%" class="text-right pr-4;">
                                                {{ newCommonFormatCurrency(c695gap, undefined) }}
                                            </td>
                                        </tr>

                                        <!-- // ** previousCreditsAllocation ** -->
                                        <tr>
                                            <!-- ** 1 -->
                                            <td width="30%" class="pl-8">
                                                {{
                                                    $t(
                                                        "audit." +
                                                            key +
                                                            ".previousCreditsAllocation",
                                                    )
                                                }}
                                            </td>

                                            <!-- ** 2 -->
                                            <td width="20%" />

                                            <!-- ** 3 -->
                                            <td width="20%" />

                                            <!-- ** 4 -->
                                            <td width="10%" class="text-right">
                                                <div>
                                                    <v-btn-icon
                                                        icon=" $oss-help"
                                                        @click="previousPaymentsSnackbar = true"
                                                    />

                                                    <v-snackbar
                                                        v-model="previousPaymentsSnackbar"
                                                        min-width="50vw"
                                                    >
                                                        <h2 class="pb-2">
                                                            Montant manuel à analyser dans le grand
                                                            livre c/444000
                                                        </h2>

                                                        <template #actions>
                                                            <v-btn-icon
                                                                icon="$oss-close"
                                                                size="small"
                                                                @click.stop="
                                                                    previousPaymentsSnackbar = false
                                                                "
                                                                class="white"
                                                            />
                                                        </template>
                                                    </v-snackbar>
                                                </div>
                                            </td>

                                            <!-- ** 5 -->
                                            <td
                                                v-if="
                                                    auditItems.validatedTax &&
                                                    auditItems.previousCreditsAllocation
                                                "
                                                width="20%"
                                                class="text-right pr-4 py-2;"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        auditItems.previousCreditsAllocation,
                                                        { currency: "", DC: true },
                                                    )
                                                }}
                                            </td>

                                            <td
                                                v-else-if="auditItems.validatedTax"
                                                width="20%"
                                                class="text-right pr-4 py-2;"
                                            >
                                                {{
                                                    newCommonFormatCurrency(0, {
                                                        currency: "",
                                                        DC: true,
                                                    })
                                                }}
                                            </td>

                                            <td v-else width="20%" class="text-right pr-4 py-2;">
                                                <oss-text-field
                                                    v-model="auditItems.previousCreditsAllocation"
                                                    :disabled="closedPeriod"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    style="width: 250px"
                                                    suffix="&#x20ac;"
                                                    @update:model-value="changeAmounts()"
                                                >
                                                </oss-text-field>
                                            </td>
                                        </tr>

                                        <!-- // ** onAccountPayments ** -->
                                        <tr>
                                            <!-- ** 1 -->
                                            <td width="30%" class="pl-8">
                                                {{ $t("audit." + key + ".onAccountPayments") }}
                                            </td>

                                            <!-- ** 2 -->
                                            <td width="20%" />

                                            <!-- ** 3 -->
                                            <td width="20%" />

                                            <!-- ** 4 -->
                                            <td width="10%" class="text-right">
                                                <div>
                                                    <v-btn-icon
                                                        icon=" $oss-help"
                                                        @click="previousPaymentsSnackbar = true"
                                                    />

                                                    <v-snackbar
                                                        v-model="previousPaymentsSnackbar"
                                                        min-width="50vw"
                                                    >
                                                        <h2 class="pb-2">
                                                            Montant manuel à analyser dans le grand
                                                            livre c/444000
                                                        </h2>

                                                        <template #actions>
                                                            <v-btn-icon
                                                                icon="$oss-close"
                                                                size="small"
                                                                @click.stop="
                                                                    previousPaymentsSnackbar = false
                                                                "
                                                                class="white"
                                                            />
                                                        </template>
                                                    </v-snackbar>
                                                </div>
                                            </td>

                                            <!-- ** 5 -->
                                            <td
                                                v-if="
                                                    auditItems.validatedTax &&
                                                    auditItems.onAccountPayments
                                                "
                                                width="20%"
                                                class="text-right py-2;"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        auditItems.onAccountPayments,
                                                        { currency: "", DC: true },
                                                    )
                                                }}
                                            </td>

                                            <td
                                                v-else-if="auditItems.validatedTax"
                                                width="20%"
                                                class="text-right py-2;"
                                            >
                                                {{
                                                    newCommonFormatCurrency(0, {
                                                        currency: "",
                                                        DC: true,
                                                    })
                                                }}
                                            </td>

                                            <td v-else width="20%" class="text-right py-2;">
                                                <oss-text-field
                                                    outlined
                                                    dense
                                                    hide-details
                                                    style="width: 250px"
                                                    suffix="&#x20ac;"
                                                    v-model="auditItems.onAccountPayments"
                                                    :disabled="closedPeriod"
                                                    @update:model-value="changeAmounts()"
                                                >
                                                    <!-- prefix="-" -->
                                                </oss-text-field>
                                            </td>
                                        </tr>

                                        <!-- // ** miscellanousTaxCredits ** -->
                                        <tr>
                                            <!-- ** 1 -->
                                            <td width="30%" class="pl-8">
                                                {{ $t("audit." + key + ".miscellanousTaxCredits") }}
                                            </td>

                                            <!-- ** 2 -->
                                            <td width="20%" />

                                            <!-- ** 3 -->
                                            <td width="20%" />

                                            <!-- ** 4 -->
                                            <td width="10%" class="text-right">
                                                <div>
                                                    <v-btn-icon
                                                        icon=" $oss-help"
                                                        @click="previousPaymentsSnackbar = true"
                                                    />

                                                    <v-snackbar
                                                        v-model="previousPaymentsSnackbar"
                                                        min-width="50vw"
                                                    >
                                                        <h2 class="pb-2">
                                                            Montant manuel à analyser dans le grand
                                                            livre c/444000
                                                        </h2>

                                                        <template #actions>
                                                            <v-btn-icon
                                                                icon="$oss-close"
                                                                size="small"
                                                                @click.stop="
                                                                    previousPaymentsSnackbar = false
                                                                "
                                                                class="white"
                                                            />
                                                        </template>
                                                    </v-snackbar>
                                                </div>
                                            </td>

                                            <!-- ** 5 -->
                                            <td
                                                v-if="
                                                    auditItems.validatedTax &&
                                                    auditItems.miscellanousTaxCredits
                                                "
                                                width="20%"
                                                class="text-right pr-4 py-2;"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        auditItems.miscellanousTaxCredits,
                                                        { currency: "", DC: true },
                                                    )
                                                }}
                                            </td>

                                            <td
                                                v-else-if="auditItems.validatedTax"
                                                width="20%"
                                                class="text-right pr-4 py-2;"
                                            >
                                                {{
                                                    newCommonFormatCurrency(0, {
                                                        currency: "",
                                                        DC: true,
                                                    })
                                                }}
                                            </td>

                                            <td v-else width="20%" class="text-right pr-4 py-2;">
                                                <oss-text-field
                                                    outlined
                                                    dense
                                                    hide-details
                                                    style="width: 250px"
                                                    suffix="&#x20ac;"
                                                    v-model="auditItems.miscellanousTaxCredits"
                                                    :disabled="closedPeriod"
                                                    @update:model-value="changeAmounts()"
                                                    data-cy="CheckCorporateTax-auditItemsMiscellanousTaxCredits"
                                                >
                                                    <!-- prefix="-" -->
                                                </oss-text-field>
                                            </td>
                                        </tr>

                                        <!-- // ** toBePaid or creditTax ** -->
                                        <tr style="background-color: #f8f8f8">
                                            <!-- ** 1 -->
                                            <td width="30%" class="pl-4" v-if="toBePaid >= 0">
                                                Reste à payer
                                            </td>

                                            <td width="30%" class="pl-4" v-else>
                                                Crédit d'IS à reporter
                                            </td>

                                            <!-- ** 2 -->
                                            <td width="20%" />

                                            <!-- ** 3 -->
                                            <td width="20%" />

                                            <!-- ** 4 -->
                                            <td width="10%" class="text-right">
                                                <div>
                                                    <v-btn-icon
                                                        icon=" $oss-help"
                                                        @click="toBePaidSnackbar = true"
                                                    />

                                                    <v-snackbar
                                                        v-model="toBePaidSnackbar"
                                                        min-width="50vw"
                                                    >
                                                        <h2 class="pb-2">
                                                            Eventuelle régularisation à
                                                            comptabiliser, par rapport au solde de
                                                            la balance
                                                        </h2>

                                                        <template #actions>
                                                            <v-btn-icon
                                                                icon="$oss-close"
                                                                size="small"
                                                                @click.stop="
                                                                    toBePaidSnackbar = false
                                                                "
                                                                class="white"
                                                            />
                                                        </template>
                                                    </v-snackbar>
                                                </div>
                                            </td>

                                            <!-- ** 5 -->
                                            <td width="20%" class="text-right pr-4">
                                                {{
                                                    newCommonFormatCurrency(Math.abs(toBePaid), {
                                                        currency: "",
                                                        DC: true,
                                                    })
                                                }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-table>

                                <v-row no-gutters class="text-right pt-4">
                                    <v-spacer />
                                    <!-- // ** enregistrer -->
                                    <v-col cols="auto" class="text-right pr-4">
                                        <!-- // ** Enregistrer -->
                                        <v-btn
                                            :disabled="closedPeriod || auditItems.validated"
                                            dense
                                            rounded
                                            elevation="0"
                                            @click="storeReinstatementsAndDeductions()"
                                            size="small"
                                        >
                                            Enregistrer
                                        </v-btn>
                                    </v-col>

                                    <!-- // ** si false > valider -->
                                    <v-col cols="auto" class="text-right">
                                        <v-btn
                                            v-if="!auditItems.validatedTax"
                                            :disabled="closedPeriod || auditItems.validated"
                                            dense
                                            rounded
                                            elevation="0"
                                            @click="
                                                auditItems.validatedTax = true;
                                                showComments = true;
                                                showTax = false;
                                                storeReinstatementsAndDeductions('VALIDATE');
                                            "
                                            size="small"
                                        >
                                            Valider le calcul d'impôt sur les sociétés
                                        </v-btn>

                                        <!-- // ** si true > invalider -->
                                        <v-btn
                                            v-else
                                            :disabled="closedPeriod || auditItems.validated"
                                            dense
                                            rounded
                                            elevation="0"
                                            @click="
                                                auditItems.validatedTax = false;
                                                storeReinstatementsAndDeductions('UPDATE');
                                            "
                                            size="small"
                                        >
                                            Invalider le calcul d'impôt sur les sociétés
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </div>
                    </v-expand-transition>
                </v-card>

                <!-- // ********* expand : comments (Synthèse) ********* -->
                <v-card class="audit-card">
                    <v-row>
                        <!-- // ** title ************** -->
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">
                                    {{ $t("audit." + key + ".resume") }}
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" />

                                <!-- // ** expand icon -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="showComments ? '$fa-chevron-up' : '$fa-chevron-down'"
                                        @click="showComments = !showComments"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-expand-transition>
                        <div v-show="showComments">
                            <v-row style="padding-left: 0; padding-right: 0">
                                <v-col style="padding-top: 0; padding-bottom: 0">
                                    <v-card-text
                                        style="background-color: white; border-radius: 25px"
                                        class="mb-4"
                                    >
                                        <div
                                            v-for="(comment, index) in auditItems.comments"
                                            :key="index"
                                            class="py-2"
                                        >
                                            <h3 class="text-uppercase pb-1">
                                                {{ comment.subtitle }}
                                            </h3>
                                            <div
                                                v-for="(commentLine, ic) in toArray(
                                                    comment.comment,
                                                )"
                                                :key="ic"
                                                class="mb-0"
                                            >
                                                <p class="mb-0">{{ commentLine }}</p>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                </v-card>

                <!-- // ** connectedDocuments -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrDocuments
                        :connectedDocuments="connectedDocuments"
                        :companyId="companyId"
                        :acKey="key"
                        :auditCheckResult="auditCheckResult || {}"
                        :accountingPeriodId="accountingPeriodId || undefined"
                        @unlinkedDocument="unlinkDocument($event)"
                        @showLinkedDocument="showLinkedDocument($event)"
                    />
                </template>

                <!-- // ** results -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrResults :results="results" :companyId="companyId" />
                </template>

                <!-- // ********* longComment  *********-->
                <v-card class="audit-card">
                    <v-row>
                        <!-- // ** title ************** -->
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires détaillés</h5>
                            </v-card-title>
                        </v-col>

                        <!-- // ** icons *************** -->
                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" />

                                <!-- // ** expand icon -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            showLongComment ? '$fa-chevron-up' : '$fa-chevron-down'
                                        "
                                        @click="showLongComment = !showLongComment"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-expand-transition no-gutters>
                        <div v-show="showLongComment" no-gutters>
                            <v-card-text>
                                <v-textarea
                                    v-model="auditItems.longComment"
                                    :disabled="closedPeriod || (auditItems && auditItems.validated)"
                                    auto-grow
                                    class="pt-1"
                                    style="border: 1px #ededed solid"
                                    outlined
                                />

                                <v-row>
                                    <v-spacer />
                                    <v-col cols="auto" class="pt-6">
                                        <v-row class="text-right">
                                            <!-- // ** OD -->
                                            <!-- <v-col cols="auto" class="text-right">
                                                <v-btn
                                                    v-if="!accountingPeriod || closedPeriod"
                                                    rounded
                                                    size="small"
                                                    elevation="0"
                                                    disabled
                                                >
                                                    OD
                                                </v-btn>
                                                <v-btn
                                                    v-else
                                                    rounded
                                                    size="small"
                                                    color="primary"
                                                    @click="createRows(); miscellaneousOperationDialog=true;"
                                                >
                                                    OD
                                                </v-btn>
                                            </v-col> -->

                                            <!-- // ** enregistrer -->
                                            <v-col cols="auto" class="text-right">
                                                <v-btn
                                                    :disabled="closedPeriod || auditItems.validated"
                                                    rounded
                                                    elevation="0"
                                                    @click="storeReinstatementsAndDeductions()"
                                                    size="small"
                                                >
                                                    Enregistrer
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </div>
                    </v-expand-transition>
                </v-card>

                <!-- // ********* shortComment ********* -->
                <v-card class="audit-card">
                    <v-row>
                        <!-- // ** title ************** -->
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires synthétiques</h5>
                            </v-card-title>
                        </v-col>

                        <!-- // ** icons *************** -->
                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" />

                                <!-- // ** expand icon -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            showShortComment ? '$fa-chevron-up' : '$fa-chevron-down'
                                        "
                                        @click="showShortComment = !showShortComment"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-expand-transition no-gutters>
                        <div v-show="showShortComment" no-gutters>
                            <v-card-text>
                                <v-textarea
                                    v-model="auditItems.shortComment"
                                    :disabled="closedPeriod || (auditItems && auditItems.validated)"
                                    auto-grow
                                    style="border: 1px #ededed solid"
                                    outlined
                                />
                                <!-- :key="i" -->

                                <!-- // ** Enregistrer valider btns -->
                                <v-row>
                                    <v-spacer />

                                    <v-col cols="auto" class="pt-6">
                                        <v-row class="text-right">
                                            <!-- // ** OD -->
                                            <!-- <v-col cols="auto" class="text-right">
                                                <v-btn
                                                    v-if="!accountingPeriod || closedPeriod"
                                                    rounded
                                                    size="small"
                                                    disabled
                                                >
                                                    OD
                                                </v-btn>
                                                <v-btn
                                                    v-else
                                                    rounded
                                                    size="small"
                                                    color="primary"
                                                    @click="createRows(); miscellaneousOperationDialog=true;"
                                                >
                                                    OD
                                                </v-btn>
                                            </v-col> -->

                                            <!-- // ** enregistrer -->
                                            <v-col cols="auto" class="text-right">
                                                <v-btn
                                                    :disabled="closedPeriod || auditItems.validated"
                                                    rounded
                                                    elevation="0"
                                                    @click="storeReinstatementsAndDeductions()"
                                                    size="small"
                                                >
                                                    Enregistrer
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </div>
                    </v-expand-transition>
                </v-card>

                <!-- // ********* expand : GeneralLedger ********* -->
                <v-card class="audit-card">
                    <v-row>
                        <!-- // ** title ************** -->
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">
                                    {{
                                        $t("audit." + key + ".balance_generalLedger") +
                                        " " +
                                        getTextFromStringArray(
                                            auditItems.auditReportAccountableAccounts,
                                        )
                                    }}
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" />

                                <!-- // ** expand icon -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            showGeneralLedger
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="showGeneralLedger = !showGeneralLedger"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-expand-transition>
                        <div v-show="showGeneralLedger">
                            <v-row class="pt-2">
                                <v-col
                                    style="padding-top: 0; padding-bottom: 0"
                                    :key="refreshGeneralLedger"
                                >
                                    <!-- // // fonctionne dans Etats -->
                                    <GeneralLedger
                                        :companyId="companyId"
                                        :accountingPeriodId="accountingPeriod.id"
                                        :accountableAccountFilter="
                                            auditItems.auditReportAccountableAccounts
                                        "
                                        v-if="accountingPeriod"
                                        @query-done="onQueryDone"
                                    >
                                    </GeneralLedger>
                                    <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                    <!-- :inNm1="true" -->
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                </v-card>

                <!-- // ********* DIALOG - CREATE GLOBAL PROVISION ******* -->
                <!-- <v-dialog
                    v-if="detailsDialog"
                    v-model="detailsDialog"
                    width="90%"
                    class="justify-space-around"
                >
                    <v-card class="pa-6">
                        <v-card-title class="px-0 pt-0 pb-2">
                            {{ $t("audit." + key + ".accountingEntriesDetails") }}
                        </v-card-title>

                        <v-window v-model="step">
                            <v-window-item :value="1">
                                <div :key="refreshDetailsGeneralLedger">
                                    <GeneralLedger
                                        v-if="accountingPeriod"
                                        :companyId="companyId"
                                        :accountingPeriodId="accountingPeriodId"
                                        :accountableAccountFilter="glAccountableAccountsRoot"
                                        :hideOptions="true"
                                        hideBodyAppend="true"
                                        @query-done="onDetailsQueryDone"
                                    >
                                    </GeneralLedger>
                                </div>

                                <v-row no-gutters class="pt-4 pb-2">
                                    <v-col>
                                        <h3>Commentaire</h3>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col style="padding-top: 0; padding-bottom: 0">
                                        <v-textarea
                                            style="
                                                padding-left: 0;
                                                padding-right: 0;
                                                border: 1px #ededed solid;
                                            "
                                            v-if="
                                                adjustmentTable &&
                                                atIndex &&
                                                adjustmentTable[atIndex]
                                            "
                                            :disabled="
                                                closedPeriod || (auditItems && auditItems.validated)
                                            "
                                            v-model="adjustmentTable[atIndex].comment"
                                            auto-grow
                                            outlined
                                        />
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col class="pa-0">
                                        <v-card-actions class="pt-2 pb-0 px-0">
                                            <v-btn
                                                rounded
                                                @click="quitDetailsDialog"
                                                color="primary"
                                            >
                                                {{ $t("audit.quit") }}
                                            </v-btn>
                                            <v-spacer />

                                            <v-btn
                                                rounded
                                                color="primary"
                                                v-if="
                                                    adjustmentTable &&
                                                    atIndex &&
                                                    adjustmentTable[atIndex]
                                                "
                                                @click="addComment(adjustmentTable[atIndex])"
                                            >
                                                {{ $t("audit." + key + ".saveComments") }}
                                            </v-btn>
                                        </v-card-actions>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                        </v-window>
                    </v-card>
                </v-dialog> -->
                <oss-dialog
                    v-if="detailsDialog"
                    v-model="detailsDialog"
                    width="90vw"
                    class="justify-space-around"
                    :title="detailsDialogTitle"
                    @valid="addComment(adjustmentTable[atIndex])"
                    @close="quitDetailsDialog"
                    :validTitle="$t('audit.' + key + '.saveComments')"
                    :validDisabled="!(adjustmentTable && atIndex && adjustmentTable[atIndex])"
                >
                    <v-window v-model="step">
                        <!-- // +++++ step 1 -->
                        <v-window-item :value="1">
                            <div :key="refreshDetailsGeneralLedger">
                                <GeneralLedger
                                    v-if="accountingPeriod"
                                    :companyId="companyId"
                                    :accountingPeriodId="accountingPeriodId"
                                    :accountableAccountFilter="glAccountableAccountsRoot"
                                    :hideOptions="true"
                                    hideBodyAppend="true"
                                    @query-done="onDetailsQueryDone"
                                >
                                </GeneralLedger>
                            </div>

                            <v-row no-gutters class="pt-4 pb-2">
                                <v-col>
                                    <h3>Commentaire</h3>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col style="padding-top: 0; padding-bottom: 0">
                                    <!-- <v-col style="padding-top: 0; padding-bottom: 0; height: auto;"> -->
                                    <!-- // atIndex error underscored : it works > ignore message -->
                                    <v-textarea
                                        style="
                                            padding-left: 0;
                                            padding-right: 0;
                                            border: 1px #ededed solid;
                                        "
                                        v-if="
                                            adjustmentTable && atIndex && adjustmentTable[atIndex]
                                        "
                                        :disabled="
                                            closedPeriod || (auditItems && auditItems.validated)
                                        "
                                        v-model="adjustmentTable[atIndex].comment"
                                        auto-grow
                                        outlined
                                    />
                                </v-col>
                            </v-row>
                        </v-window-item>
                    </v-window>
                </oss-dialog>
                <!-- ++ regenerateBundleDialog -->
                <oss-dialog
                    v-model="regenerateBundleDialog"
                    v-if="regenerateBundleDialog"
                    title="Mise à jour à faire"
                    valid-title="Aller à la page de la liasse fiscale"
                    @valid="
                        regenerateBundleDialog = false;
                        $router.push(auditItems.bundleErrorMessage.path);
                    "
                    @close="regenerateBundleDialog = false"
                    min-width="60vw"
                >
                    <template
                        v-if="
                            auditItems.bundleErrorMessage && auditItems.bundleErrorMessage.message
                        "
                    >
                        <div v-html="auditItems.bundleErrorMessage.message" />
                    </template>

                    <p v-else>
                        Le grand livre a été modifié. Veuillez recalculer la liasse fiscale ou créer
                        une liasse rectificative.
                    </p>
                </oss-dialog>

                <!-- ++ generate new bundle dialog -->
                <oss-dialog
                    v-model="generateNewBundleDialog"
                    v-if="generateNewBundleDialog"
                    title="Aucune liasse fiscale enregistrée"
                    valid-title="Ouvrir une nouvelle liasse fiscale"
                    @valid="
                        generateNewBundleDialog = false;
                        $router.push({ name: 'taxForm2-new' });
                    "
                    @close="generateNewBundleDialog = false"
                    min-width="60vw"
                >
                    <p class="text-center">
                        Ce contrôle se base sur les données contenues dans la liasse fiscale.
                    </p>
                </oss-dialog>

                <!-- ++ displayActivityDialog -->
                <oss-dialog
                    v-model="displayActivityDialog"
                    v-if="displayActivityDialog"
                    title="Activité"
                    valid-title="Fermer"
                    @valid="displayActivityDialog = false"
                    @close="displayActivityDialog = false"
                    min-width="60vw"
                >
                    <UsersActivitiesHistory
                        :auditCheckKey="acKey"
                        :accountingPeriodId="accountingPeriodId"
                    >
                    </UsersActivitiesHistory>
                </oss-dialog>

                <!-- ++ deleteAuditCheckResultDialog -->
                <template v-if="deleteAuditCheckResultDialog">
                    <AuditDeleteAuditCheckResultDialog
                        v-model="deleteAuditCheckResultDialog"
                        :auditCheckResultId="auditCheckResult.id"
                        @closed="
                            deleteAuditCheckResultLoading = false;
                            deleteAuditCheckResultDialog = false;
                        "
                        @deletedAcr="deleteAcrDone"
                    />
                    <!-- deleteAuditCheckResultLoading="deleteAuditCheckResultLoading" -->
                </template>

                <Chat
                    :auditCheckAccountingPeriodKey="chatId"
                    v-if="openChat"
                    v-bind:chatTitle="'Chat'"
                />
                <AuditCheckDocumentsManager
                    v-model="dialogAuditCheckDocumentsManager"
                    v-if="dialogAuditCheckDocumentsManager"
                    :disabled="loading || dataLoading || !accountingPeriod"
                    :companyId="companyId"
                    :documentToDisplay="documentToDisplay"
                    :connectedDocuments="connectedDocuments || []"
                    :acKey="key"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    :alreadyLinkedDoc="alreadyLinkedDoc"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        alreadyLinkedDoc = false;
                        documentToDisplay = {};
                    "
                />
            </template>
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
// import { State2Way } from "@/decorators";
import { Apollo } from "@/decorators";
import {
    mathFix,
    newCommonFormatCurrency,
} from "../../../../backend/src/common/services/mathServices";
import { getTextFromStringArray } from "../../../../backend/src/common/audit/auditFunctions";
import { closedPeriod, formatConnectedDocuments } from "../../services/audit/AuditServices";
import { getDBFormattedStartDate, getDBFormattedEndDate } from "../../services/dateServices";

import GeneralLedger from "../GeneralLedger2.vue";
import AccountingTable from "../dashboardAccounting/AccountingTable.vue";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import Chat from "../chat/Chat.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import AuditDeleteAuditCheckResultDialog from "./AuditDeleteAuditCheckResultDialog.vue";

// //////////////////// APOLLO ////////////////////////
import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";
import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import { getEmptyDocument } from "../../services/documentServices";

import {
    calculateTax,
    calculateAdjustmentTableSums,
} from "../../../../backend/src/common/audit/auditFunctions";

import { CheckBase } from "./CheckBase";
import { getConnectAccountableAccount } from "../../services/accountableAccountServices";
import TaxFormReadOnly from "../taxForm/TaxFormReadOnly.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        GeneralLedger,
        AccountingTable,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        AuditConnectedAcrResults,
        Chat,
        UsersActivitiesHistory,
        AuditDeleteAuditCheckResultDialog,
        TaxFormReadOnly,
    },
})
export class CheckCorporateTax extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;

    loading: boolean = false;
    dataLoading: boolean = true;
    deleteAuditCheckResultLoading: boolean = false;

    dialogAuditCheckDocumentsManager: boolean = false;

    corporateTaxSnackbar: boolean = false;
    previousPaymentsSnackbar: boolean = false;
    toBePaidSnackbar: boolean = false;
    toBeBookedSnackbar: boolean = false;

    refreshGeneralLedger: number = 0;
    refreshDetailsGeneralLedger: number = 0;
    refreshAccountingTable: number = 0;

    // validatedTable: boolean = false
    // validatedTax: boolean = false

    showIncomeStatement: boolean = false;
    showTable: boolean = false;
    showComments: boolean = false;
    showShortComment: boolean = false;
    showLongComment: boolean = false;
    showGeneralLedger: boolean = false;
    showTax: boolean = false;

    showDeleteAcrBtnTooltipMessage: string = "";

    dialog: boolean = false;
    detailsDialog: boolean = false;
    deleteAuditCheckResultDialog: boolean = false;
    regenerateBundleDialog: boolean = false;
    generateNewBundleDialog: boolean = false;

    // accountingPeriod: any = null;
    year: string;
    endPeriodDate: string = "";
    // withAccountingPeriod: boolean = false;
    company: any = {};

    key: string = "yZCapzwZiGhZ81RFS40tDW8i";
    auditCheckResult: any = null;

    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    atIndex: Number = 0;
    acrData: Array<any> = [];

    step: number = 1;
    detailsList: Array<any> = [];

    expanded: Array<any> = [];
    singleExpand: Boolean = false;

    booked695Amount: number = 0;
    netResultAmount: number = 0;

    c695gap: number = 0;
    toBePaid: number = 0;
    toBeBooked: number = 0;
    onlyManualOdsFromBalances695: number = 0;
    onlyAcrResultsFromBalance695: number = 0;

    previousDocumentsIds: Array<any> = [];

    c101300: number = 0;

    alreadyLinkedDoc: boolean = false;

    preTaxIncome: number = 0;

    // get selectedCompany() {
    //     return this.$store.state.selected_company;
    // }

    get checkStatus() {
        if (this.auditItems.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.auditItems.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.auditItems.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.auditItems.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.auditItems.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    get detailsDialogTitle() {
        return this.$t("audit." + this.key + ".accountingEntriesDetails");
    }

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    getTextFromStringArray(array: Array<string>) {
        return getTextFromStringArray(array);
    }

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
    }

    afterAccountingPeriodFound() {
        if (this.accountingPeriod) {
            this.year = moment(this.accountingPeriod.end).format("YYYY");
            this.endPeriodDate = moment(this.accountingPeriod.end).format("YYYY-MM-DD");
        }
    }

    // ++++++++++++ CHECK HEADERS - MISSING SALES-INVOICES +++++++++

    adjustmentTableHeaders: Array<any> = [
        {
            title: "Comptes",
            key: "accountableAccounts",
            align: "center",
            justify: "left",
            sortable: false,
        },
        {
            title: "",
            key: "wording",
            align: "center",
            justify: "left",
            sortable: false,
        },
        {
            title: "Réf Liasse RN",
            key: "normalTaxSystem",
            align: "center",
            justify: "center",
            sortable: false,
        },
        {
            title: "Réf Liasse RSI",
            key: "bncTaxSystem",
            align: "center",
            justify: "center",
            sortable: false,
        },
        {
            title: "Comptabilité",
            key: "computedAmountSigned",
            align: "center",
            justify: "right",
            sortable: false,
        },
        {
            title: "Manuel",
            key: "manualAmountSigned",
            align: "center",
            justify: "right",
            sortable: false,
        },
        {
            title: "Commentaire",
            key: "data-table-expand",
            justify: "center",
            sortable: false,
        },
    ];

    detailsHeaders: Array<any> = [
        {
            title: "Type",
            key: "document",
            // align: "center",
            justify: "left",
            sortable: true,
        },
        {
            title: "Description",
            key: "wording",
            // align: "center",
            justify: "left",
            sortable: true,
        },
        {
            title: "Date",
            key: "date",
            // align: "center",
            justify: "left",
            sortable: true,
        },
        {
            title: "Montant",
            key: "amountSigned",
            // align: "center",
            justify: "right",
            sortable: true,
        },
    ];

    get periodsAccountingTable() {
        if (this.accountingPeriod) {
            const apT = [
                {
                    start: getDBFormattedStartDate(this.accountingPeriod.start),
                    end: getDBFormattedEndDate(this.accountingPeriod.end),
                    // accountingPeriodId: this.accountingPeriod.id,
                },
            ];
            return apT;
        } else {
            return null;
        }
    }

    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheck: "CheckCorporateTax",
                auditCheckKey: this.key,
                accountingPeriodId: this.accountingPeriodId,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            // if (!loading && data && data.auditItems && data.auditItems.items && !data.auditItems.items.length) {
            //     this.initialiseCompany()
            //     this.$router.go(-1)
            //     // if (this.accountingPeriods && this.accountingPeriodId) {
            //     //     this.accountingPeriod = this.accountingPeriods.find(ap => ap.id === this.accountingPeriodId)
            //     // }
            // } else
            if (!loading && data) {
                this.initialiseCompany();
                this.dataLoading = true;

                if (data?.auditItems?.items?.[0]) {
                    this.auditItems = data.auditItems.items[0];

                    if (this.auditItems.bundleSheetToRegenerate) {
                        this.regenerateBundleDialog = true;
                    }

                    // this.auditItems.shareCapital = auditItems.shareCapital
                    // this.year = this.auditItems.year || undefined

                    this.fullyPaidCapital = this.auditItems.fullyPaidCapital || false;

                    this.corporateTaxAmount = this.auditItems.corporateTaxAmount || 0;
                    this.customerCorporateTaxObject = this.auditItems.customerCorporateTaxObject;
                    this.corporateTaxRates = this.auditItems.corporateTaxRates || [];

                    if (this.auditItems.bundleSheetId) {
                        this.bundleSheetId = this.auditItems.bundleSheetId;
                    } else if (!this.accountingPeriod?.closed) {
                        this.generateNewBundleDialog = true;
                    } else if (this.auditItems.adjustmentTable?.length) {
                        this.bundleSheetId = null;
                        this.adjustmentTable = this.auditItems.adjustmentTable || [];
                    }

                    // this.auditCheckKey = auditItems.auditCheckKey
                    this.toBePaid = this.auditItems.toBePaid || 0;
                    this.toBeBooked = this.auditItems.toBeBooked || 0;
                    this.preTaxIncome = this.auditItems.preTaxIncome || 0;
                    this.c101300 = this.auditItems.c101300 || 0;
                    this.netResultAmount = this.auditItems.netResultAmount || 0;
                    this.booked695Amount = this.auditItems.booked695Amount || 0;

                    this.periodPreTaxIncomeBracket0 =
                        this.auditItems.periodPreTaxIncomeBracket0 || 0;
                    this.periodPreTaxIncomeBracket1 =
                        this.auditItems.periodPreTaxIncomeBracket1 || 0;
                    this.periodTurnoverBracket0 = this.auditItems.periodTurnoverBracket0 || 0;
                    this.fullPeriodTurnoverBracket0 =
                        this.auditItems.fullPeriodTurnoverBracket0 || 0;
                    this.periodTurnoverBracket1 = this.auditItems.periodTurnoverBracket1 || 0;
                    this.fullPeriodTurnoverBracket1 =
                        this.auditItems.fullPeriodTurnoverBracket1 || 0;
                    this.naturalPersonsSharesRateOver75 =
                        this.auditItems.naturalPersonsSharesRateOver75 || false;

                    this.deleteAuditCheckResultDialog = false;
                    this.deleteAuditCheckResultLoading = false;

                    if (this.auditItems.auditCheckResult?.id) {
                        this.auditCheckResult =
                            this.auditItems.auditCheckResult?.[0] ||
                            this.auditItems.auditCheckResult ||
                            {};

                        this.connectedDocuments = this.auditCheckResult?.documents || [];

                        this.results = this.auditCheckResult?.results || [];

                        this.previousDocumentsIds = this.auditItems?.previousDocumentsIds || [];

                        this.validated = this.auditItems?.validated || false;

                        this.reviewed = this.auditCheckResult?.reviewed || 0;
                    }

                    this.undoValidatedTax();

                    // this.reducedRateAmount = auditItems.reducedRateAmount || 0,
                    // this.normalRateAmount = auditItems.normalRateAmount || 0,
                    // this.overrunRateAmount = auditItems.overrunRateAmount || 0,

                    // this.periodMonthDuration = auditItems.periodMonthDuration
                } else {
                    this.auditItems = {};
                }
                this.dataLoading = false;
            }
        },
    })
    auditItems: any = {};

    bundleSheetId: string = null;

    corporateTaxAmount: number = 0;

    customerCorporateTaxObject: any = {};

    corporateTaxRates: Array<any> = [];

    adjustmentTable: Array<any> = [];

    periodTurnoverBracket0: number = 0;

    fullPeriodTurnoverBracket0: number = 0;

    periodTurnoverBracket1: number = 0;

    fullPeriodTurnoverBracket1: number = 0;

    periodPreTaxIncomeBracket0: number = 0;

    periodPreTaxIncomeBracket1: number = 0;

    fullyPaidCapital: boolean = false;

    naturalPersonsSharesRateOver75: boolean = false;

    reviewed: number = 0;

    async storeReinstatementsAndDeductions(action = undefined) {
        if (this.auditItems?.year) {
            this.createComments();

            const data = {
                validated: false,
                longComment: "",
                shortComment: "",
                resume: {},
                table: [],
            };

            data.validated = this.auditItems.validated || false;
            data.shortComment = this.auditItems.shortComment || "";
            data.longComment = this.auditItems.longComment || "";
            data.resume = {
                customerCorporateTaxObject: this.customerCorporateTaxObject || undefined,
                naturalPersonsSharesRateOver75: this.naturalPersonsSharesRateOver75 || false,
                previousCreditsAllocation: this.auditItems.previousCreditsAllocation || 0,
                onAccountPayments: this.auditItems.onAccountPayments || 0,
                miscellanousTaxCredits: this.auditItems.miscellanousTaxCredits || 0,
                validatedTable: this.auditItems.validatedTable || false,
                validatedTax: this.auditItems.validatedTax || false,
                comments: this.auditItems.comments || undefined,
                fullyPaidCapital: this.fullyPaidCapital,
                // corporateTaxRate1: this.corporateTaxRate1 ||
            };

            if (this.adjustmentTable?.length) {
                for (const at of this.adjustmentTable) {
                    if (at.normalTaxSystem) {
                        // not title lines
                        data.table.push({
                            tableBlock: at.tableBlock,
                            manualAmountSigned: at.manualAmountSigned,
                            comment: at.comment || undefined,
                        });
                    }
                }
            }

            const documents = [];

            if (!this.toBeBooked) {
                this.previousDocumentsIds = [];
            } else {
                let wording = "";

                if (this.toBeBooked === this.corporateTaxAmount) {
                    wording += "Impôt sur les sociétés - " + this.auditItems?.year;
                } else {
                    wording += "Régul s/Impôt sur les sociétés - " + this.auditItems?.year;
                }

                wording += this.customerCorporateTaxObject.reduced.taxRate
                    ? " - " + this.customerCorporateTaxObject.reduced.taxRate + "%"
                    : "";

                wording += this.customerCorporateTaxObject.normal.taxRate
                    ? " - " + this.customerCorporateTaxObject.normal.taxRate + "%"
                    : "";

                wording += this.customerCorporateTaxObject.overrun.taxRate
                    ? " - " + this.customerCorporateTaxObject.overrun.taxRate + "%"
                    : "";

                const accountingLines = [];

                // const toBeBooked = JSON.parse(JSON.stringify(this.toBeBooked));

                accountingLines.push({
                    date: this.endPeriodDate,
                    wording: wording,
                    amountSigned: this.toBeBooked,
                    amount: this.toBeBooked,
                    // amountSigned: toBeBooked,
                    // amount: toBeBooked,
                    thirdPartyCompany: undefined,
                    // thirdPartyCompany: {connect: { id: invoice.thirdPartyCompany.id}},
                    accountableAccount: await getConnectAccountableAccount(
                        this.$store,
                        this.$apollo,
                        this.auditItems.accountableAccount695,
                    ),
                    company: { connect: { id: this.companyId } },
                    type: "MANAGACCOU",
                });

                accountingLines.push({
                    date: this.endPeriodDate,
                    wording: wording,
                    amountSigned: -this.toBeBooked,
                    amount: this.toBeBooked,
                    // amountSigned: -toBeBooked,
                    // amount: toBeBooked,
                    // accountableAccountName: "444000"
                    thirdPartyCompany: undefined,
                    accountableAccount: await getConnectAccountableAccount(
                        this.$store,
                        this.$apollo,
                        "444000",
                    ),
                    company: { connect: { id: this.companyId } },
                    type: "MANAGACCOU",
                });

                const document: any = getEmptyDocument(
                    this.companyId,
                    wording,
                    "MISCELLANEOUS_OPERATION",
                    this.endPeriodDate,
                    this.currentUser.id,
                    null,
                    accountingLines,
                    true,
                );

                documents.push(document);
            }

            let auditCheckResultVariables: any = {};

            if (this.key && this.companyId && this.accountingPeriodId && data) {
                auditCheckResultVariables = {
                    id: this.auditCheckResult?.id || "",
                    key: this.key + "_" + this.companyId + "_" + this.accountingPeriodId,
                    companyId: this.companyId,
                    status: this.auditItems.validated ? "VALIDATED" : "EDITION",
                    // thirdPartyCompany: {connect: {id: this.selectedCustomer.id}},
                    // thirdPartyCompanyCreate: al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id ? { connect: { id:al.object.thirdPartyCompany.id } } : undefined,
                    // thirdPartyCompanyUpdate: al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id ? { connect: { id:al.object.thirdPartyCompany.id } } : undefined,
                    accountingPeriodCreate: this.accountingPeriodId
                        ? { connect: { id: this.accountingPeriodId } }
                        : undefined,
                    accountingPeriodUpdate: this.accountingPeriodId
                        ? { connect: { id: this.accountingPeriodId } }
                        : undefined,
                    deleteDocuments: documents?.length ? this.previousDocumentsIds : [], // ** previous results, if to delete
                    documents: documents || [], // ** results = générés par le contrôle
                    connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
                    data,
                    auditCheckKey: this.key,
                    type: "IN_AUDIT_REPORT",
                    reviewed: this.reviewed,
                };
            }

            if (auditCheckResultVariables) {
                const acrUpdated = await this.$apollo.mutate({
                    mutation: UPSERT_AUDIT_CHECK_RESULT,
                    variables: auditCheckResultVariables,
                });

                if (acrUpdated) {
                    this.refresh();
                }
            }

            // await this.createUserActivity(action) // deprecated
        }
    }

    refresh() {
        this.initialiseCompany();
        this.refreshAccountingTable += 1;

        if (this.$apollo.queries && this.$apollo.queries.auditItems) {
            this.$apollo.queries.auditItems.refetch();
            this.refreshGeneralLedger++;
        } else {
            debugger; // git-ignore
        }
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    async validateFunction() {
        if (!this.auditItems.validated) {
            this.auditItems.validated = !this.auditItems.validated;
            await this.storeReinstatementsAndDeductions("VALIDATE");
        } else {
            this.invalidate();
            this.reviewed = 0;
            await this.storeReinstatementsAndDeductions("UPDATE");
        }
    }

    async changeAmounts() {
        if (this.auditItems?.year) {
            if (this.adjustmentTable?.length) {
                await calculateAdjustmentTableSums(this.adjustmentTable);
            }

            const calculatedTax: any = await calculateTax(
                this.adjustmentTable,
                this.bundleSheetId,
                this.preTaxIncome,
                this.accountingPeriod,
                this.auditItems.year,
                this.naturalPersonsSharesRateOver75,
                this.auditItems.salesTurnover,
                this.customerCorporateTaxObject,
                this.auditItems.previousCreditsAllocation,
                this.auditItems.onAccountPayments,
                this.auditItems.miscellanousTaxCredits,
                this.auditItems.preTaxIncomeBrackets,
                this.auditItems.turnoverBrackets,
                this.auditItems.corporateTaxRates,
                this.fullyPaidCapital,
                this.auditItems.corporateTaxInBundleSheet,
                this.auditItems.balances695,
                this.results,
            );

            this.corporateTaxAmount = calculatedTax?.corporateTaxAmount || 0;
            this.c695gap = calculatedTax?.c695gap || 0;

            if (this.c695gap) {
                this.auditItems.validatedTax = false;
            }
            this.toBePaid = calculatedTax?.toBePaid || 0;
            this.toBeBooked = calculatedTax?.toBeBooked || 0;
            this.onlyManualOdsFromBalances695 = calculatedTax?.onlyManualOdsFromBalances695 || 0;
            this.onlyAcrResultsFromBalance695 = calculatedTax?.onlyAcrResultsFromBalance695 || 0;
            this.periodPreTaxIncomeBracket0 = calculatedTax?.periodPreTaxIncomeBracket0 || 0;
            this.periodPreTaxIncomeBracket1 = calculatedTax?.periodPreTaxIncomeBracket1 || 0;
            this.periodTurnoverBracket0 = calculatedTax?.periodTurnoverBracket0 || 0;
            this.fullPeriodTurnoverBracket0 = calculatedTax?.fullPeriodTurnoverBracket0 || 0;
            this.periodTurnoverBracket1 = calculatedTax?.periodTurnoverBracket1 || 0;
            this.fullPeriodTurnoverBracket1 = calculatedTax?.fullPeriodTurnoverBracket1 || 0;
            this.previousDocumentsIds =
                calculatedTax?.previousDocumentsIds || this.previousDocumentsIds || [];

            this.createComments();
        }
    }

    // ** shows documents of adjustmentTable line group
    setDetailsList(data) {
        if (this.auditItems?.year && this.adjustmentTable?.length) {
            this.glAccountableAccountsRoot = data.accountableAccounts || [];

            this.detailsDialog = true;
            this.atIndex = this.adjustmentTable.indexOf(data);
        }
    }

    openDocument(data) {
        if (data) {
            this.$router.push({
                name: "document",
                params: {
                    companyId: data.document.company.id,
                    id: data.document.id,
                },
            });
        }
    }

    quitDetailsDialog() {
        this.detailsDialog = false;
        this.step = 1;
    }

    initialiseCompany() {
        this.loading = false;
        // this.validatedTable = false
        // this.validatedTax = false

        // this.showTable = false
        // this.showComments = false
        this.showGeneralLedger = false;
        // this.showTax = false

        this.refreshDetailsGeneralLedger++;

        this.detailsDialog = false;

        this.company = null;

        // this.accountingPeriod = {}
        this.year = "";
        // this.endPeriodDate = ""

        this.auditItems = [];

        this.adjustmentTable = [];
        this.auditCheckResult = {};
        this.atIndex = 0;
        this.acrData = [];
        this.detailsList = [];

        this.auditCheckResult = {};

        this.quitDetailsDialog();
    }

    accountableAccountNames(arr) {
        let aaList = "";
        for (const aa of arr) {
            aaList = aaList.concat(aa, " ");
        }
        return aaList;
    }

    addAdjustmentTableExpand(item) {
        item.displayComment = !item.displayComment;

        const index = this.expanded.findIndex((i) => i.wording === item.wording);
        if (index === -1) {
            this.expanded.push(item);
        } else {
            this.expanded.splice(index, 1);
        }
    }

    addComment(item) {
        if (this.auditItems?.year && this.adjustmentTable?.length) {
            const index = this.adjustmentTable.indexOf(item);
            if (index !== -1) {
                this.adjustmentTable[index].comment = item.comment;
                this.createComments();
                this.quitDetailsDialog();
            }
        }
    }

    createComments() {
        if (this.auditItems?.year) {
            this.auditItems.comments = [];

            if (this.adjustmentTable?.length) {
                for (const i of this.adjustmentTable) {
                    const translated = this.$t("audit." + this.key + "." + i.tableBlock);
                    if (i.comment) {
                        if (i.wording) {
                            this.auditItems.comments.push({
                                subtitle: translated,
                                comment: i.comment,
                            });
                        }
                    }
                }
            }

            const finalComment = {
                subtitle: "Calcul de l'impôt sur les sociétés",
                comment: "",
            };

            if (this.bundleSheetId) {
                if (this.preTaxIncome >= 0) {
                    finalComment.comment +=
                        "Résultat fiscal (perte): " +
                        newCommonFormatCurrency(this.preTaxIncome) +
                        "\n";
                    finalComment.comment += "Pas imposable\n";
                } else {
                    finalComment.comment +=
                        "Résultat fiscal imposable (bénéfice) : " +
                        newCommonFormatCurrency(-this.preTaxIncome) +
                        "\n";
                }
            } else if (this.adjustmentTable?.length) {
                if (
                    this.adjustmentTable[31].manualAmountSigned &&
                    this.adjustmentTable[31].manualAmountSigned >= 0
                ) {
                    finalComment.comment +=
                        "Résultat fiscal (perte): " +
                        newCommonFormatCurrency(this.adjustmentTable[31].manualAmountSigned) +
                        "\n";
                    finalComment.comment += "Pas imposable\n";
                } else {
                    finalComment.comment +=
                        "Résultat fiscal imposable (bénéfice) : " +
                        newCommonFormatCurrency(-this.adjustmentTable[31].manualAmountSigned) +
                        "\n";
                }
            }

            if (this.auditItems.salesTurnover) {
                finalComment.comment +=
                    "CA : " + newCommonFormatCurrency(-this.auditItems.salesTurnover);
            }

            if (this.periodTurnoverBracket0) {
                finalComment.comment +=
                    " - Plafond taux réduit : " +
                    newCommonFormatCurrency(Math.abs(this.periodTurnoverBracket0));
            }
            if (this.auditItems.turnoverBrackets[0][this.year]) {
                if (
                    this.auditItems.periodMonthDuration != 12 &&
                    this.auditItems.fullPeriodTurnoverBracket0
                ) {
                    finalComment.comment +=
                        " (prorata de " +
                        this.auditItems.periodMonthDuration +
                        " mois de " +
                        newCommonFormatCurrency(this.auditItems.fullPeriodTurnoverBracket0) +
                        ")";
                }
                finalComment.comment += "\n";
            }
            finalComment.comment += "\n";

            finalComment.comment +=
                "Capital social : " +
                newCommonFormatCurrency(this.auditItems.shareCapital, { currency: "", DC: true });

            finalComment.comment +=
                " (dont versé : " +
                newCommonFormatCurrency(this.c101300, { currency: "", DC: true }) +
                ")\n";

            finalComment.comment +=
                "Parts du capital social détenu par des personnes physiques supérieures à 75% : ";
            if (this.naturalPersonsSharesRateOver75) {
                finalComment.comment += "OUI\n";
            } else {
                finalComment.comment += "NON\n";
            }

            finalComment.comment += "\n";

            for (const sentence of this.customerCorporateTaxSentence()) {
                finalComment.comment += sentence + "\n";
            }

            finalComment.comment +=
                "Total IS de l'année : " + newCommonFormatCurrency(this.corporateTaxAmount) + "\n";

            if (this.auditItems.previousCreditsAllocation != 0) {
                finalComment.comment +=
                    this.$t("audit." + this.key + ".previousCreditsAllocation") +
                    " : " +
                    newCommonFormatCurrency(this.auditItems.previousCreditsAllocation) +
                    "\n";
            }

            if (this.auditItems.onAccountPayments != 0) {
                finalComment.comment +=
                    this.$t("audit." + this.key + ".onAccountPayments") +
                    " : " +
                    newCommonFormatCurrency(this.auditItems.onAccountPayments) +
                    "\n";
            }

            if (this.auditItems.miscellanousTaxCredits != 0) {
                finalComment.comment +=
                    this.$t("audit." + this.key + ".miscellanousTaxCredits") +
                    " : " +
                    newCommonFormatCurrency(this.auditItems.miscellanousTaxCredits) +
                    "\n";
            }

            if (this.toBePaid >= 0) {
                finalComment.comment +=
                    this.$t("audit." + this.key + ".toBePaid") +
                    " : " +
                    newCommonFormatCurrency(this.toBePaid);
            } else {
                finalComment.comment +=
                    this.$t("audit." + this.key + ".creditTax") +
                    " : " +
                    newCommonFormatCurrency(Math.abs(this.toBePaid));
            }

            if (this.toBeBooked) {
                finalComment.comment +=
                    "\n" + "Ecriture générée : " + newCommonFormatCurrency(this.toBeBooked);
            }

            this.auditItems.comments.push(finalComment);
        }
    }

    // ** <GeneralLedger - grand livre
    async onQueryDone(data) {
        if (this.auditItems?.year && this.adjustmentTable?.length) {
            await calculateTax(
                this.adjustmentTable,
                this.bundleSheetId,
                this.preTaxIncome,
                this.accountingPeriod,
                this.auditItems.year,
                this.naturalPersonsSharesRateOver75,
                this.auditItems.salesTurnover,
                this.customerCorporateTaxObject,
                this.auditItems.previousCreditsAllocation,
                this.auditItems.onAccountPayments,
                this.auditItems.miscellanousTaxCredits,
                this.auditItems.preTaxIncomeBrackets,
                this.auditItems.turnoverBrackets,
                this.auditItems.corporateTaxRates,
                this.fullyPaidCapital,
                this.auditItems.corporateTaxInBundleSheet,
                this.auditItems.balances695,
                this.results,
            );
            this.createComments();
        }
    }

    async onDetailsQueryDone(data) {}

    // ** <AccountingTable incomeStatement - compte de résultat
    // ** used only in closed period, without bundleSheetId
    fetchResult(data) {}

    @Watch("adjustmentTable", { deep: true })
    onAdjustmentTableChange() {
        this.changeAmounts();
    }

    toArray(comment) {
        if (comment) {
            const carriedTexts = comment.split("\n");
            return carriedTexts;
        }
        return [];
    }

    async openTax() {
        this.showTax = !this.showTax;

        if (this.auditItems?.year && this.adjustmentTable?.length) {
            const calculatedTax: any = await calculateTax(
                this.adjustmentTable,
                this.bundleSheetId,
                this.preTaxIncome,
                this.accountingPeriod,
                this.auditItems.year,
                this.naturalPersonsSharesRateOver75,
                this.auditItems.salesTurnover,
                this.customerCorporateTaxObject,
                this.auditItems.previousCreditsAllocation,
                this.auditItems.onAccountPayments,
                this.auditItems.miscellanousTaxCredits,
                this.auditItems.preTaxIncomeBrackets,
                this.auditItems.turnoverBrackets,
                this.auditItems.corporateTaxRates,
                this.fullyPaidCapital,
                this.auditItems.corporateTaxInBundleSheet,
                this.auditItems.balances695,
                this.results,
            );

            this.corporateTaxAmount = calculatedTax?.corporateTaxAmount || 0;
            this.toBePaid = calculatedTax?.toBePaid || 0;
            this.toBeBooked = calculatedTax?.toBeBooked || 0;
            this.onlyManualOdsFromBalances695 = calculatedTax?.onlyManualOdsFromBalances695 || 0;
            this.onlyAcrResultsFromBalance695 = calculatedTax?.onlyAcrResultsFromBalance695 || 0;
            this.periodPreTaxIncomeBracket0 = calculatedTax?.periodPreTaxIncomeBracket0 || 0;
            this.periodPreTaxIncomeBracket1 = calculatedTax?.periodPreTaxIncomeBracket1 || 0;
            this.periodTurnoverBracket0 = calculatedTax?.periodTurnoverBracket0 || 0;
            this.fullPeriodTurnoverBracket0 = calculatedTax?.fullPeriodTurnoverBracket0 || 0;
            this.periodTurnoverBracket1 = calculatedTax?.periodTurnoverBracket1 || 0;
            this.fullPeriodTurnoverBracket1 = calculatedTax?.fullPeriodTurnoverBracket1 || 0;
            this.previousDocumentsIds =
                calculatedTax?.previousDocumentsIds || this.previousDocumentsIds || [];
        }
    }

    undoValidatedTax() {
        if (this.auditItems) {
            if (this.auditItems.validatedTax) {
                if (this.adjustmentTable?.length && !this.auditItems.validatedTable) {
                    this.auditItems.validatedTax = false;
                    this.storeReinstatementsAndDeductions();
                } else if (this.corporateTaxAmount) {
                    if (this.corporateTaxAmount !== this.auditItems.corporateTaxFromBalances695) {
                        this.auditItems.validatedTax = false;
                        this.storeReinstatementsAndDeductions();
                    }
                }
            }
        }
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
        return false;
    }

    invalidate() {
        this.auditItems.validated = false;
        this.auditItems.validatedTable = false;
        this.auditItems.validatedTax = false;
    }

    get disabledBtnGlobalValidation() {
        if (this.accountingPeriod?.closed) {
            return true;
        }

        if (
            (!this.bundleSheetId && !this.auditItems?.validatedTable) ||
            !this.auditItems?.validatedTax
        ) {
            return true;
        }
        return false;
    }

    get showDeleteAcrBtnIfRecovery() {
        if (this.auditCheckResult?.id) {
            if (this.closedPeriod) {
                this.showDeleteAcrBtnTooltipMessage = "Exercice N clôturé";
                return false;
            }
            return true;
        }
        this.showDeleteAcrBtnTooltipMessage = "Aucun contrôle";
        return false;
    }

    deleteAcrDone() {
        this.deleteAuditCheckResultLoading = false;
        this.deleteAuditCheckResultDialog = false;
        this.refresh();
    }

    customerCorporateTaxSentence() {
        const sentences = [];

        if (
            this.customerCorporateTaxObject?.reduced &&
            this.customerCorporateTaxObject.reduced.taxBase &&
            this.customerCorporateTaxObject.reduced.taxRate &&
            this.customerCorporateTaxObject.reduced.taxAmount
        ) {
            let sentence =
                "Taux réduit (plafonné à " +
                newCommonFormatCurrency(Math.abs(this.periodPreTaxIncomeBracket0)) +
                " de bénéfice";

            if (this.auditItems.periodMonthDuration != 12) {
                sentence +=
                    " - prorata de " +
                    this.auditItems.periodMonthDuration +
                    " mois de " +
                    newCommonFormatCurrency(this.auditItems.preTaxIncomeBracket0, {
                        currency: "",
                        DC: true,
                    });
            }
            sentence +=
                ") - Base " +
                newCommonFormatCurrency(Math.abs(this.customerCorporateTaxObject.reduced.taxBase)) +
                " - " +
                this.customerCorporateTaxObject.reduced.taxRate +
                "% - IS " +
                newCommonFormatCurrency(
                    Math.abs(this.customerCorporateTaxObject.reduced.taxAmount),
                );
            sentences.push(sentence);
        }

        if (
            this.customerCorporateTaxObject.normal &&
            this.customerCorporateTaxObject.normal.taxBase &&
            this.customerCorporateTaxObject.normal.taxRate &&
            this.customerCorporateTaxObject.normal.taxAmount
        ) {
            let sentence = "Taux normal ";
            if (this.periodPreTaxIncomeBracket1 !== 0) {
                sentence +=
                    "(plafonné à " +
                    newCommonFormatCurrency(Math.abs(this.periodPreTaxIncomeBracket1));
                if (this.auditItems.periodMonthDuration != 12) {
                    sentence +=
                        " prorata de " +
                        this.auditItems.periodMonthDuration +
                        " mois de " +
                        newCommonFormatCurrency(this.auditItems.preTaxIncomeBracket1, {
                            currency: "",
                            DC: true,
                        });
                }
            } else {
                sentence += "(sans plafond";
            }

            sentence +=
                ") - Base " +
                newCommonFormatCurrency(Math.abs(this.customerCorporateTaxObject.normal.taxBase)) +
                " - " +
                this.customerCorporateTaxObject.normal.taxRate +
                "% - IS " +
                newCommonFormatCurrency(Math.abs(this.customerCorporateTaxObject.normal.taxAmount));
            sentences.push(sentence);
        }

        if (
            this.customerCorporateTaxObject.overrun &&
            this.customerCorporateTaxObject.overrun.taxBase &&
            this.customerCorporateTaxObject.overrun.taxRate &&
            this.customerCorporateTaxObject.overrun.taxAmount
        ) {
            const sentence =
                "Taux exédentaire : Base " +
                newCommonFormatCurrency(Math.abs(this.customerCorporateTaxObject.overrun.taxBase)) +
                " - " +
                this.customerCorporateTaxObject.overrun.taxRate +
                "% - IS " +
                newCommonFormatCurrency(
                    Math.abs(this.customerCorporateTaxObject.overrun.taxAmount),
                );
            sentences.push(sentence);
        }
        return sentences;
    }
}

export default toNative(CheckCorporateTax);
</script>
